// Channels API — список каналов пользователя для project selector

export interface Channel {
  uuid: string
  maxChannelID: string
  title: string
  iconUrl: string | null
  isActive: boolean
  tariff: string
  paidUntilEpoch: string | null
  memberCount: number
  // true если канал не принадлежит currentUser'у, но superadmin имеет к нему
  // read-доступ (backend SHA 2d2942a5). Пока используется опционально для
  // будущего UI-индикатора «Просмотр как админ»; отсутствие поля = «свой».
  isForeign?: boolean
}

export interface ChannelsResponse {
  channels: Channel[]
}

const USE_MOCKS = false

const MOCK_CHANNELS: Channel[] = [
  {
    uuid: '0322ef44-9ad1-4100-867f-bab2351cc622',
    maxChannelID: '-69092437303297',
    title: 'Телеграфикс | Подписчики в Max',
    iconUrl: null,
    isActive: true,
    tariff: 'profi',
    paidUntilEpoch: '2030-01-13T22:00:00Z',
    memberCount: 5445,
  },
  {
    uuid: '4d492828-f329-40ea-8c24-8e0889747da1',
    maxChannelID: '-70292750901249',
    title: 'Тестовый канал TGX',
    iconUrl: null,
    isActive: true,
    tariff: 'free',
    paidUntilEpoch: null,
    memberCount: 12,
  },
]

// Optional query-фильтр для superadmin. 'showcase' → бэк вернёт только
// каналы у которых max_showcase.status IS NOT NULL (activated хотя бы раз).
// 'all' (или отсутствие) → все isActive каналы (для superadmin — до 500,
// для обычного юзера — его собственные).
export type ChannelFilter = 'all' | 'showcase'

export async function getChannels(opts?: { filter?: ChannelFilter }): Promise<ChannelsResponse> {
  if (USE_MOCKS) {
    await new Promise((r) => setTimeout(r, 200))
    return { channels: MOCK_CHANNELS }
  }
  const params = new URLSearchParams()
  if (opts?.filter === 'showcase') params.set('filter', 'showcase')
  const qs = params.toString()
  const res = await fetch(`/api/max/channels${qs ? `?${qs}` : ''}`, { credentials: 'include' })
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
